import React from "react";

const useBodyScrollLock = () => {
  const bodyStyle = document.body.style;

  const [isLocked, setIsLocked] = React.useState(
    bodyStyle.overflowY === "hidden"
  );

  React.useEffect(() => {
    bodyStyle.overflowY = isLocked ? "hidden" : "auto";
  }, [bodyStyle, isLocked]);

  const toggle = () => setIsLocked(!isLocked);

  return [isLocked, toggle]
};

export default useBodyScrollLock;
